import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des facturations
 */
@Injectable()
export class FacturationService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/facturation";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction pour lancer la facturation
   */
  public proc_lancerFacturation(
    i_mois: number,
    i_annee: number,
    f_mail: boolean,
    f_suppr: boolean
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/lancerFacturation`,
      JSON.stringify({
        mois: i_mois,
        annee: i_annee,
        fmail: f_mail,
        fsuppr: f_suppr
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction pour lancer la generation brouillard
   */
  public proc_generationBrouilard(
    mois: number,
    annee: number
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/brouillard`,
      JSON.stringify({ mois: mois, annee: annee }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction pour lancer la generation des declarations tiers
   */
  public proc_generationDeclarationtiers(
    mois: number,
    annee: number
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/declarationTiers`,
      JSON.stringify({ mois: mois, annee: annee }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction pour lancer la generation des prelevements tiers
   */
  public proc_generationPrelevementTiers(
    mois: number,
    annee: number
  ): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/prelevementTiers`,
      JSON.stringify({ mois: mois, annee: annee }),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/facturation.service.ts